var React = require('react');

function LeftPointingArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.539571 5.48666C0.286174 5.74095 0.2869 6.15251 0.541193 6.4059L4.68502 10.5352C4.93931 10.7886 5.35087 10.7878 5.60427 10.5335C5.85766 10.2793 5.85694 9.8677 5.60265 9.61431L1.91923 5.94385L5.58967 2.26041C5.84307 2.00612 5.84235 1.59457 5.58805 1.34118C5.33376 1.08778 4.9222 1.08851 4.6688 1.3428L0.539571 5.48666ZM536.999 4.35L0.99883 5.29547L1.00112 6.59547L537.001 5.65L536.999 4.35Z","fill":"#1B1A1A"}));
}

LeftPointingArrow.defaultProps = {"width":"538","height":"11","viewBox":"0 0 538 11","fill":"none"};

module.exports = LeftPointingArrow;

LeftPointingArrow.default = LeftPointingArrow;
